"use client";

import React from "react";
import ContentfulDisclaimer from "./disclaimer";

interface DisclaimerProps {
  className?: string;
  style?: React.CSSProperties;
  bigMaxWidth?: boolean;
}

const Disclaimer: React.FC<DisclaimerProps> = (props) => {
  return <ContentfulDisclaimer {...props} />;
};

export default Disclaimer;
